// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__kJ-_b","icon":"EnquiryForm_icon__y_tru","heading":"EnquiryForm_heading__Kd4FH","field":"EnquiryForm_field__1bnuv","error":"EnquiryForm_error__MjtIH"};